/**
 * Do not edit directly, this file was auto-generated.
 */

export enum Sizes {
  XXS = 'xxs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
}

export const px = {
  [Sizes.XXS]: '375px',
  [Sizes.XS]: '480px',
  [Sizes.SM]: '600px',
  [Sizes.MD]: '768px',
  [Sizes.LG]: '1024px',
  [Sizes.XL]: '1280px',
  [Sizes.XXL]: '1440px',
};

export const rem = {
  [Sizes.XXS]: '23.4375rem',
  [Sizes.XS]: '30rem',
  [Sizes.SM]: '37.5rem',
  [Sizes.MD]: '48rem',
  [Sizes.LG]: '64rem',
  [Sizes.XL]: '80rem',
  [Sizes.XXL]: '90rem',
};
